document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.product__accordion details');
  accordions.forEach((accordion) => {
    const content = accordion.querySelector('.accordion__content');
    
    if (accordion.open) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }
    
    accordion.addEventListener('toggle', () => {
      if (accordion.open) {
        // Close other accordions
        accordions.forEach((other) => {
          if (other !== accordion && other.open) {
            other.removeAttribute('open');
            const otherContent = other.querySelector('.accordion__content');
            if (otherContent) {
              otherContent.style.maxHeight = null;
            }
          }
        });
        
        // Animate opening
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        // Animate closing
        content.style.maxHeight = null;
      }
    });
  });
  
  // Optional: Add resize listener to update heights
  window.addEventListener('resize', () => {
    accordions.forEach((accordion) => {
      if (accordion.open) {
        const content = accordion.querySelector('.accordion__content');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const galleryItem = document.querySelectorAll(".gallery-item");
  const lightboxImg = document.getElementById("lightbox-image");
  const lightBox = document.querySelector(".lightbox");
  const article = document.querySelector("body");

  function showLightbox(item) {
    if (!lightBox || !article) return;

    lightBox.style.opacity = "1";
    lightBox.style.visibility = "visible";
    lightBox.style.transform = "scale(1) translate(-50%, -50%)";

    const imageSource = item.src.replace("-thumbnail", "");
    lightboxImg.src = imageSource;

    article.classList.add("lightbox-active");

    // 🔹 LIGHTBOX KE PAAS SCROLL
    lightBox.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }

  galleryItem.forEach(item => {
    item.addEventListener("click", () => {
      showLightbox(item);
    });
  });

  if (lightBox) {
    lightBox.addEventListener("click", (event) => {
      if (event.target === lightBox || event.target.id === "close-btn") {
        lightBox.style.opacity = "0";
        lightBox.style.visibility = "hidden";
        lightBox.style.transform = "scale(0)";

        article.classList.remove("lightbox-active");
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function() {
  // Get product name from URL
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  const productNameFromUrl = getUrlParameter('product_name');
 // console.log('Product name from URL:', productNameFromUrl);

  if (!productNameFromUrl) return;

  const decodedProductName = decodeURIComponent(productNameFromUrl);
  let fieldFound = false;

  // Function to properly set value with all required events
  function setFieldValue(field, value) {
   // console.log('Setting field value properly...');
    
    // Focus the field first (some frameworks need this)
    field.focus();
    
    // Set the value property (for React/JavaScript frameworks)
    field.value = value;
    
    // Also set the attribute (for some validation libraries)
    field.setAttribute('value', value);
    
    // Trigger all the events that the framework might be listening to
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    field.dispatchEvent(new Event('blur', { bubbles: true }));
    
    // For React specifically
    const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype, 
      'value'
    ).set;
    
    if (nativeInputValueSetter) {
      nativeInputValueSetter.call(field, value);
      field.dispatchEvent(new Event('input', { bubbles: true }));
    }
    
    // Make it read-only
    field.readOnly = true;
    console.log('✓ Field value properly set:', field.value);
  }

  // Search through shadow DOM
  function searchInShadowDOM(root = document, depth = 0) {
    // Check all inputs in current context
    const inputs = root.querySelectorAll('input');
    inputs.forEach(input => {
      // Look for first name field by various identifiers
      if (
        input.id === 'custom#product_title' ||
        input.getAttribute('data-testid')?.includes('field-custom#product_title')
      ) {
        console.log(`✓ Found field at depth ${depth}:`, {
          id: input.id,
          name: input.name,
          type: input.type
        });
        setFieldValue(input, decodedProductName);
        fieldFound = true;
      }
    });

    // If found, stop searching
    if (fieldFound) return true;

    // Search in shadow roots
    root.querySelectorAll('*').forEach(element => {
      if (element.shadowRoot && !fieldFound) {
        console.log(`Entering shadow DOM of ${element.tagName}, depth: ${depth + 1}`);
        searchInShadowDOM(element.shadowRoot, depth + 1);
      }
    });

    return fieldFound;
  }

  // Main function to wait and search
  function initializeFormFill() {
    //console.log('Starting form fill process...');
    
    // Try immediately
    if (searchInShadowDOM()) {
      //console.log('✓ Field filled on first attempt');
      return;
    }

    // Set up observer for dynamic content
    const observer = new MutationObserver(function() {
      //console.log('DOM changed, searching for field...');
      if (!fieldFound) {
        searchInShadowDOM();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Special handling for Shopify Forms component
    const formComponent = document.querySelector('shopify-forms-embed');
    if (formComponent) {
     // console.log('Found Shopify Forms component, adding special listener');
      
      // Try multiple times as the component loads
      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
       // console.log(`Attempt ${attempts} to find field...`);
        
        if (searchInShadowDOM() || attempts > 20) {
          clearInterval(interval);
          observer.disconnect();
          if (attempts > 20) {
            console.log('Max attempts reached');
            tryAlternativeMethods();
          }
        }
      }, 500);
    }

    // Fallback after 10 seconds
    setTimeout(() => {
      observer.disconnect();
      if (!fieldFound) {
       // console.log('Trying fallback methods...');
        tryAlternativeMethods();
      }
    }, 10000);
  }

  // Alternative methods if direct manipulation doesn't work
  function tryAlternativeMethods() {
   // console.log('Trying alternative methods...');
    
    // Method 1: Try to use the app's own JavaScript API
    if (window.ShopifyForms && typeof window.ShopifyForms.setFieldValue === 'function') {
     // console.log('Using Shopify Forms API');
      window.ShopifyForms.setFieldValue('field-custom#product_title', decodedProductName);
    }
    
    // Method 2: Dispatch a custom event the app might listen to
    const prefillEvent = new CustomEvent('shopify-forms:prefill', {
      detail: {
        fields: {
          product_title: decodedProductName
        }
      }
    });
    document.dispatchEvent(prefillEvent);
    //console.log('Dispatched prefill event');
    
    // Method 3: Try URL hash method
    window.location.hash = `#product_title=${encodeURIComponent(decodedProductName)}`;
    
    // Method 4: Create a hidden form and use it
    const hiddenForm = document.createElement('form');
    hiddenForm.style.display = 'none';
    hiddenForm.innerHTML = `<input name="product_title" value="${decodedProductName}">`;
    document.body.appendChild(hiddenForm);
   // console.log('Created hidden form with value');
  }

  // Start the process after a short delay
  setTimeout(initializeFormFill, 100);
});

var acc = document.getElementsByClassName("accordian-box");

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {

    this.classList.toggle("active");
    var panel = this.querySelector(".panel");

    if (!panel) return;

    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

// mobile drawer menu links
document.addEventListener('click', function (event) {
  const summary = event.target.closest('summary[data-link]');
  if (!summary) return;

  const caret = event.target.closest('.caret-icon');
  const url = summary.dataset.link;

  if (caret) return;

  if (!url || url === '#') {
    return; 
  }

  event.preventDefault();
  event.stopPropagation();
  window.location.href = url;
});

// cancel address form to scroll up
document.addEventListener('click', function (e) {
  // Shopify cancel buttons usually have these classes
  if (
    e.target.classList.contains('cancel-form') ||
    e.target.closest('.cancel-form') ||
    e.target.name === 'cancel'
  ) {
    // Smooth scroll to top (mobile friendly)
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 50);
  }
});

// Hire it now Button js
document.addEventListener("click", function(e) {

  const hireBtn = e.target.closest("#hire-now-btn");
  if (!hireBtn) return;

  e.preventDefault();

  const form = hireBtn.closest("form");
  if (!form) return;

  const formData = new FormData(form);

  hireBtn.disabled = true;
  hireBtn.innerText = "Processing...";

  fetch("/cart/add.js", {
    method: "POST",
    body: formData
  })
  .then(res => res.json())
  .then(() => {
    window.location.href = "/checkout";
  })
  .catch(err => {
    console.error("Error adding rental product:", err);
    hireBtn.disabled = false;
    hireBtn.innerText = "Hire it Now";
  });

});